/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Error_Encryption_UnavailableInputs */

const vi_smartlab_irrigation_error_encryption_unavailable = /** @type {(inputs: Smartlab_Irrigation_Error_Encryption_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy chủ chưa cấu hình khóa mã hóa SmartLab (SMARTLAB_ENCRYPTION_KEY), chưa lưu được mật khẩu`)
};

/**

* @param {Smartlab_Irrigation_Error_Encryption_UnavailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_error_encryption_unavailable = /** @type {((inputs?: Smartlab_Irrigation_Error_Encryption_UnavailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Error_Encryption_UnavailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_error_encryption_unavailable(inputs)
});